import { connect } from "react-redux";
import React, { useState } from "react";
import { InputNumber } from "antd";

import ConfirmButton from "../../../components/buttons/ConfirmButton";

import { setUserAmounts } from "../../../modules/presence/api/api";
import { handleError } from "../../../modules/presence/sagas";

const UserRegularBonusForm = ({ getLimitsBonusesList, closeModal, token, user_id }) => {
  const [monthlyAmount, setMonthlyAmount] = useState(0);
  const [quarterlyAmount, setQuarterlyAmount] = useState(0);

  const onSubmit = async () => {
    const dataToSend = {
      monthly_amount: monthlyAmount,
      quarterly_amount: quarterlyAmount,
      user_id
    };
    try {
      await setUserAmounts(dataToSend, token);

      getLimitsBonusesList();
      closeModal();
    } catch (e) {
      console.log("e", e, e.response);
      handleError(e);
    }
  };

  return (
    <div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant de la prime mensuelle</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={monthlyAmount}
          onChange={setMonthlyAmount}
        />
      </div>
      <div className="flex justify-between items-center mb-4">
        <div className="">Montant de la prime trimestrielle</div>
        <InputNumber
          style={{ backgroundColor: "#f0f0f0", borderRadius: "11px", borderColor: "#f0f0f0", width: "300px" }}
          min={0}
          value={quarterlyAmount}
          onChange={setQuarterlyAmount}
        />
      </div>
      <div className="pt-6 flex justify-center mt-6">
        <ConfirmButton label={"Appliquer"} large={true} onClick={onSubmit} />
      </div>
    </div>
  );
};

const mapStateToProps = state => {
  return {
    token: state.auth.token
  };
};

export default connect(mapStateToProps)(UserRegularBonusForm);



// WEBPACK FOOTER //
// src/containers/admin/premium/UserRegularBonus.form.js